/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import { StatisticsWidget2 } from '../statistics/StatisticsWidget2'

type Props = {
  className: string
  percent: string[]
  count: string[]
  compositionGender: any
}

const ListsWidget9: React.FC<Props> = ({className, percent, count, compositionGender}) => {
  return (
    <div className={clsx('card', className)}>
      {/* begin::Header */}
      <div className='card-header align-items-center border-0 mt-3'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bolder text-dark fs-3'>Gender Composition</span>
          {/* <span className='text-gray-400 mt-2 fw-bold fs-6'>More than 400+ new members</span> */}
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <StatisticsWidget2
        className='card-lg-5 mb-xl-7'
        avatar='/media/svg/avatars/029-boy-11.svg'
        title={compositionGender.male?.count}
        description={`${compositionGender.male?.percent}%`}
      />
      <StatisticsWidget2
        className='card-lg-5 mb-xl-7'
        avatar='/media/svg/avatars/014-girl-7.svg'
        title={compositionGender?.female?.count}
        description={`${compositionGender?.female?.percent}%`}
      />
      {/* end::Body */}
    </div>
  )
}

export {ListsWidget9}
